import { create } from 'zustand';

const useEmployerStore = create((set, get) => ({
  // State
  profile: null,
  companyData: {},
  notifications: [],
  loading: false,
  error: null,

  // Actions
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Add specific actions here
}));

export default useEmployerStore;